import React from 'react';
import { useTelegram } from '../hooks/useTelegram';
import { useSettingsStore } from '../store';
import { Button } from './ui/Button';

export const BlockedScreen: React.FC = () => {
  const { openTelegramLink } = useTelegram();
  const { settings } = useSettingsStore();

  const handleSupport = () => {
    if (settings.supportUrl) {
      openTelegramLink(settings.supportUrl);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[300] flex flex-col items-center justify-center px-6"
      style={{ background: '#F2F2F7' }}
    >
      <div className="text-center max-w-sm">
        <p className="text-lg font-semibold text-text-primary mb-2">
          Доступ ограничен
        </p>
        <p className="text-sm text-text-secondary mb-6">
          Ваш аккаунт заблокирован. По вопросам разблокировки обратитесь в поддержку.
        </p>
        <Button
          variant="primary"
          size="lg"
          fullWidth
          onClick={handleSupport}
        >
          Поддержка
        </Button>
      </div>
    </div>
  );
};
